angular.module('unica_event.event_controllers')

.controller('EventCreateController', function(
	$rootScope, $scope, $state,
	EventCreateService
) {

	$scope.pageTitle = 'Crea evento';

	$rootScope.resetEventData();

	$rootScope.getServicesUsers();

	$scope.saveEvent = function() {
		$scope.showLoader();

		var eventData = angular.copy($rootScope.eventData);
		eventData.stages = $scope.parseDatesFromDateToTimestamp(eventData.stages);

		if ( eventData.votation_closing_date ) {
			eventData.votation_closing_date = moment( eventData.votation_closing_date ).format('YYYY-MM-DD');
		}

		EventCreateService
			.create(eventData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Evento aggiunto con successo!', '');
					$state.go('app.event.edit', { year: $rootScope.year, id: data.id });
				} else {
					$rootScope.manageError(data);
				}

			});

	};

})

;